import React, { Fragment } from 'react';

import Portal from '../../utils/Portal';
import { useSettings } from '../../mall_settings/SettingsProvider';

import { UserLoginStatus } from './UserLoginStatus';
import { UserLoginWidgetDefault } from './UserLoginWidgetDefault';

export const UserLoginWidget = () => {
    const { authenticationOptional, authenticationRequired } = useSettings();
    return (
        <Fragment>
            {authenticationRequired && <UserLoginStatus />}
            {authenticationOptional && <UserLoginWidgetDefault />}
        </Fragment>
    );
};

const UserLoginWidgetPortal = () => (
    <Fragment>
        {document.getElementById('auth_block') && (
            <Portal id="auth_block">
                <UserLoginWidget />
            </Portal>
        )}
    </Fragment>
);

export default UserLoginWidgetPortal;
